module.exports = __webpack_public_path__ + "img/house.19d326c6.jpg";